// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"76":"common","636":"adyen","962":"paypal","988":"stripe"}[chunkId] + "-" + {"76":"ba1aa0998eac630949f3","636":"603a3d98f5ec074d6128","962":"8be641d909c12eccebbd","988":"2fbcddfd45ccf938ecb4"}[chunkId] + ".js";
};